module.exports = __webpack_public_path__ + "static/img/10.215ea44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/10.png
// module id = xzy/
// module chunks = 0